import { useState } from 'react';
import { AlertsFilters } from './filters';
import { AlertsList } from './list';
import { ALERTS_NEW, ALERTS } from '../../../../routes/paths';
import { LayoutModule } from '../../../layout/modules';
import { AlertsFilter } from '../../../../shared/types/legalProceedings/alerts';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import {
    isOnlyViewProfile,
    isOperativeProfile,
} from '../../../../shared/types/profiles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

export const Alerts = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [filters, setFilters] = useState<AlertsFilter>();

    return (
        <>
            <LayoutModule
                title="Búsqueda de reglas alertas"
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show:
                                !isOnlyViewProfile(type) &&
                                !isOperativeProfile(type),
                            route: ALERTS_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: ALERTS,
                        }}
                    />
                }
            >
                <AlertsFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <AlertsList filters={filters} />
        </>
    );
};
